import React, { useState } from 'react';
import CollapsibleSection from './CollapsibleSection';
import ProductDropdown from '../CreateSidebar/ProductDropdown';
import BrushSizeSection from './BrushSizeSection';
import ProductModal from '../../Modals/ProductModal';
import uploadImageIcon from '../../../assets/icons/upload_image.png';
import InfoTooltip from '../../common/InfoTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const AddProductSection = ({
  brushSize,
  setBrushSize,
  eraserSize,
  setEraserSize,
  activeTool,
  setActiveTool,
  handleFileUpload,
  uploadedImage,
  setUploadedImage,
  selectedProduct,
  setSelectedProduct,
  setRefNum,
  setCreditsAvailable,
  handleProductSelect,
  isOpen,
  onToggle,
  sectionId,
  setProductPrompt
}) => {
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState(brushSize);
  const [showAreaInfo, setShowAreaInfo] = useState(false);

  return (
    <>
      <CollapsibleSection
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            Edit with Image
            <InfoTooltip iconSize={14}>
            Add or Modify by creating mask and selecting your product. 
            </InfoTooltip>
          </div>
        }
        isOpen={isOpen}
        onToggle={onToggle}
        sectionId={sectionId}
      >
        <div style={{ marginBottom: '1rem' }}> {/* Reduced from 1.2rem */}
          <BrushSizeSection
            activeButton={activeTool}
            setActiveButton={setActiveTool}
            brushSize={brushSize}
            eraserSize={eraserSize}
            inputValue={inputValue}
            setInputValue={setInputValue}
            setBrushSize={setBrushSize}
            setEraserSize={setEraserSize}
            showAreaInfo={showAreaInfo}
            setShowAreaInfo={setShowAreaInfo}
          />
        </div>
        {/* Upload Image Section */}
        <div style={{ marginBottom: '1rem' }}>
          <div style={{ fontWeight: 500, marginBottom: 6, fontSize: '0.875rem' }}>Upload Image</div>
          <label className="flex items-center justify-between p-1 border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer group relative overflow-hidden bg-white">
            <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFileUpload} />
            <div className="absolute inset-0 bg-gradient-to-r from-[#4B3BFF] to-[#7B6BFF] opacity-0 group-hover:opacity-5 transition-all duration-300"></div>
            {uploadedImage ? (
              <>
                <div className="flex items-center space-x-3 relative">
                  <img
                    src={uploadedImage}
                    alt="Uploaded"
                    className="w-10 h-10 rounded-lg group-hover:scale-110 transition-transform duration-300 object-cover"
                  />                
                </div>
                <div className="flex items-center relative z-10">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setUploadedImage(null);
                    }}
                    className="mr-1 text-gray-400 hover:text-red-500 transition-all duration-300 relative z-20"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                  </button>
                  <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 group-hover:text-[#4B3BFF] group-hover:translate-x-1 transition-all duration-300 relative z-10 pr-2" />
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center space-x-3 relative">
                  <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <img
                    src="https://img.icons8.com/?size=100&id=6RfZ-eZQz0ee&format=png&color=737373"
                    alt="Uploaded"
                    className="w-10 h-10 rounded-lg group-hover:scale-110 transition-transform duration-300 object-cover"
                  /> 
                  </div>
                  <span className="text-sm text-gray-800 group-hover:text-[#4B3BFF] transition-colors duration-300">Reference Image</span>
                </div>
                <div className="flex items-center relative z-10">
                  <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 group-hover:text-[#4B3BFF] group-hover:translate-x-1 transition-all duration-300 relative z-10 pr-2" />
                </div>
              </>
            )}
          </label>
        </div>

        {/* OR separator */}
        <div style={{ textAlign: 'center', margin: '0.75rem 0', position: 'relative' }}> {/* Reduced margin from 1rem to 0.75rem */}
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '10%',
            right: '10%',
            height: '1px',
            backgroundColor: '#e5e7eb',
            transform: 'translateY(-50%)'
          }}></div>
          <span style={{
            backgroundColor: 'white',
            padding: '0 0.75rem',
            color: '#6b7280',
            fontSize: '0.75rem', // Reduced font size
            position: 'relative',
            zIndex: 1
          }}>OR</span>
        </div>

        <div style={{ marginBottom: '1rem' }}> {/* Reduced from 1.2rem */}
          <div style={{ fontWeight: 500, marginBottom: 6, fontSize: '0.875rem' }}>Select from Library</div> {/* Reduced margin and font size */}
          <ProductDropdown
            selectedProduct={selectedProduct}
            setIsProductModalOpen={setIsProductModalOpen}
            setSelectedProduct={setSelectedProduct}
            setProductPrompt={setProductPrompt}
          />
        </div>

        
      </CollapsibleSection>
      
        <ProductModal
          isOpen={isProductModalOpen}
          onRequestClose={() => setIsProductModalOpen(false)}
          mode="select"
          selectedProduct={selectedProduct}
          handleProductSelect={handleProductSelect}
          setRefNum={setRefNum}
          setCreditsAvailable={setCreditsAvailable}
          setProductPrompt={setProductPrompt}
          setIsProductModalOpen={setIsProductModalOpen}
        />
    </>
  );
};

export default AddProductSection; 